<div class="header-container">
  <div class="header-content">
    <h3>{{ taxpayerAlias }} Comments</h3>

    <label class="show-archived">
      <span>Show archived</span>
      <input
        type="checkbox"
        [checked]="showArchived"
        (input)="toggleShowArchived()"
      />
    </label>
  </div>
</div>

<div class="scrollable-container hidden-scrollbar">
  <div class="comments-container">
    @for (comment of visibleComments; track commentTrackBy(i, comment); let i =
    $index) {
    <div class="comment" [ngClass]="{ archived: !!comment.archivedAt }">
      @if (comment.noticeInfo) {
      <div class="comment-notice-info">
        {{ comment.noticeInfo }}
      </div>
      }
      <div class="comment-header">
        <span class="name">{{ makeName(comment.user) }}</span>
        <span class="date">{{ comment.postDate }}</span>
      </div>
      @if (!comment.editing) {
      <div class="comment-message">
        <div [innerHTML]="comment.message"></div>
      </div>
      }
      <div [hidden]="!comment.editing">
        <textarea
          #commentEditBox
          [(ngModel)]="comment.editingMessage"
        ></textarea>
        <button
          class="ui primary button"
          [ngClass]="{ loading: comment.saving }"
          [disabled]="
            comment.saving ||
            !comment.editingMessage ||
            comment.editingMessage == comment.message
          "
          (click)="editComment(comment)"
        >
          Update Comment
        </button>
        <button
          class="ui button"
          [ngClass]="{ loading: comment.saving }"
          [disabled]="comment.saving"
          (click)="cancelEditing(comment)"
        >
          Cancel
        </button>
      </div>
      @if (!comment.editing && comment.editDate) {
      <div class="edit-date">Last edited {{ comment.editDate }}</div>
      } @if (!comment.editing) {
      <div class="actions">
        @if (!comment.archivedAt) { @if (comment.user?.id == userInfo.id) {
        <i
          class="ui icon pencil alternate"
          title="Edit"
          (click)="!comment.saving && startEditing(comment, i)"
        ></i>
        }
        <i
          class="ui icon archive"
          title="Archive"
          (click)="!comment.saving && archiveComment(comment, true)"
        ></i>
        } @if (!!comment.archivedAt) { Archived
        <i
          class="ui icon archive"
          title="Un-archive"
          (click)="!comment.saving && archiveComment(comment, false)"
        ></i>
        }
      </div>
      }
    </div>
    }
  </div>

  <span
    class="ui inline small loader"
    [ngClass]="{ active: loadingComments }"
  ></span>

  <textarea
    placeholder="Enter comment..."
    [(ngModel)]="commentText"
    [disabled]="saving"
  ></textarea>
  <button
    class="ui primary button"
    [ngClass]="{ loading: saving }"
    [disabled]="saving || !commentText"
    (click)="postComment()"
  >
    Post Comment
  </button>
</div>
